export default __webpack_public_path__ + "static/media/extra_out_d2.47d01990.svg";